<template>
    <c-dialog ref="dialog" title="售后申请单详情" mode="slide" width="80vw" enable-flex mask-close :button="false">
        <template #head>
            <div v-if="detailData.aftersale_apply_no" class="m-detail-tag flex-center-cross">
                <label>{{detailData.aftersale_apply_no}}</label>
                <c-state v-if="detailData.tags && detailData.tags.indexOf('测试')!=-1" dict="applyTagShortDic" tag value="测"></c-state>
                <c-state dict="orderTransferStatusDic" tag :value="detailData.order_transfer_status"></c-state>
            </div>
        </template>

        <module>
            <module-col size="450">
                <c-detail class="m-detail-form">
                    <c-title>基本信息</c-title>
                    <c-detail-item label="申请单编号">
                        {{detailData.aftersale_apply_no}}
                    </c-detail-item>
                    <c-detail-item label="申请单状态">
                        {{detailData.apply_status}}
                    </c-detail-item>
                    <c-detail-item label="关联工单">
                         <c-link v-if="detailData.work_order_id" @click="globalDialog('afterSaleOrderDetail', {props: {id: detailData.work_order_id}})">{{detailData.work_order_no||'--'}}</c-link>
                    </c-detail-item>
                    <c-detail-item label="服务类型">
                        {{detailData.service_type}}
                    </c-detail-item>
                    <c-detail-item label="售后类别">
                        {{detailData.aftersale_type}}
                    </c-detail-item>
                    <c-detail-item label="服务内容">
                        {{detailData.service_content}}
                    </c-detail-item>
                    <c-detail-item label="是否收费">
                        {{detailData.is_charge}}
                    </c-detail-item>
                    <c-detail-item label="预估收费金额">
                        {{detailData.estimated_fee ? '￥' + detailData.estimated_fee : ''}}
                    </c-detail-item>
                    <c-detail-item label="预估人数">
                        {{detailData.estimated_person}}
                    </c-detail-item>
                    <c-detail-item label="预计人员到达时间">
                        {{detailData.eost_date}}
                    </c-detail-item>
                    <c-detail-item label="实收上门服务费">
                        {{detailData.actual_visit_fee ? '￥' + detailData.actual_visit_fee : ''}}
                    </c-detail-item>
                    <c-detail-item label="备注">
                        {{detailData.remark}}
                    </c-detail-item>
                    <c-detail-item label="意见处理单">
                        {{detailData.complaint_no}}
                    </c-detail-item>
                    <c-detail-item label="销售部门编号">
                        {{detailData.sales_dept_no}}
                    </c-detail-item>
                </c-detail>
                <c-detail class="m-detail-form">
                    <c-title>客户信息</c-title>

                    <c-detail-item label="客户名称">
                        {{detailData.customer_name}}
                    </c-detail-item>
                    <c-detail-item label="联系人">
                        {{detailData.customer_contact}}
                    </c-detail-item>
                    <c-detail-item label="联系电话">
                        {{detailData.customer_phone}}
                    </c-detail-item>
                    <c-detail-item label="售后地址">
                        {{detailData.aftersale_address}}
                    </c-detail-item>
                    <c-detail-item label="地址定位">
                        <c-link icon="tf-address" @click="globalDialog('locationSelector', {props: {lnglat: `${detailData.address_longitude},${detailData.address_latitude}`}})">查看位置</c-link>
                    </c-detail-item>
                    <c-detail-item label="网点-客户距离">
                        {{detailData.net_address_count}} km
                    </c-detail-item>
                    <c-detail-item label="公司">
                        {{detailData.service_net_code}}
                    </c-detail-item>
                    <c-detail-item label="所属部门">
                        {{detailData.depart_name}}
                    </c-detail-item>
                </c-detail>
                <c-detail class="m-detail-form">
                    <c-title>业务信息</c-title>
                    <c-detail-item label="服务类别">
                        {{detailData.service_category}}
                    </c-detail-item>
                    <c-detail-item label="业务员姓名">
                        {{detailData.salesman_name}}
                    </c-detail-item>
                    <c-detail-item label="业务员电话">
                        {{detailData.salesman_phone}}
                    </c-detail-item>
                    <c-detail-item label="申请单所有人">
                        {{detailData.apply_owner}}
                    </c-detail-item>
                    <c-detail-item label="创建时间" colspan="2">
                        {{detailData.apply_create_time}}
                    </c-detail-item>
                    <c-detail-item label="审核人">
                        {{detailData.apply_auditor}}
                    </c-detail-item>
                    <c-detail-item label="审核时间">
                        {{detailData.apply_audit_time}}
                    </c-detail-item>
                    <c-detail-item label="分配网点">
                        {{detailData.authorized_outlet_name}}
                    </c-detail-item>
                </c-detail>
            </module-col>

            <module-col >
                <c-detail v-if="detailData.service_progress" class="m-detail-form m-progress-center">
                    <c-steps  :steps="serviceProgressDic" :active="detailData.service_progress" gap="100" style="padding: 10px;"></c-steps>
                </c-detail>
                <div class="m-detail-box">
                    <c-title>售后服务明细</c-title>
                    <c-table ref="itemTable" border :paging="false">
                        <c-table-column
                                label="存货编码"
                                width="100"
                                name="inventory_code"
                        >
                            <template #default="{data}">
                                <c-link @click="globalDialog('productDetail', {props: {inventory_code: data.inventory_code}})">{{data.inventory_code||'--'}}</c-link>
                            </template>
                        </c-table-column>
                        <c-table-column
                                label="存货名称"
                                width="260"
                                name="inventory_name"
                        >
                            <template #default="{data}">
                                {{data.inventory_name || '-'}}
                            </template>
                        </c-table-column>
                        <c-table-column label="规格型号" width="260" name="spec_model">
                            <template #default="{data}">
                                {{data.spec_model}}
                            </template>
                        </c-table-column>
                        <c-table-column label="长（mm）" width="100" name="length">
                            <template #default="{data}">
                                {{data.length}}
                            </template>
                        </c-table-column>
                        <c-table-column label="宽（mm）" width="100" name="width">
                            <template #default="{data}">
                                {{data.width}}
                            </template>
                        </c-table-column>
                        <c-table-column label="数量" width="100" name="quantity">
                            <template #default="{data}">
                                {{data.quantity}}
                            </template>
                        </c-table-column>
                        <c-table-column label="件数" width="100" name="pieces">
                            <template #default="{data}">
                                {{data.pieces}}
                            </template>
                        </c-table-column>
                        <c-table-column label="环接方式" width="100" name="connection_method">
                            <template #default="{data}">
                                {{data.connection_method}}
                            </template>
                        </c-table-column>
                        <c-table-column label="备注" width="100" name="item_remark">
                            <template #default="{data}">
                                {{data.item_remark}}
                            </template>
                        </c-table-column>
                    </c-table>
                    
                    <template v-if="detailData.work_order_id">
                        <c-title>关联工单</c-title>
                        <c-table ref="orderTable" border :paging="false">
                            <c-table-column
                                    label="工单编号"
                                    width="145"
                                    name="order_number"
                            >
                                <template #default="{data}">
                                    <c-link @click="globalDialog('afterSaleOrderDetail', {props: {id: data.id}})">{{data.order_number||'--'}}</c-link>
                                </template>
                            </c-table-column>
                            <c-table-column
                                    label="售后网点"
                                    width="100"
                                    name="after_sale_outlet_name"
                            >
                                <template #default="{data}">
                                    {{data.after_sale_outlet_name}}
                                </template>
                            </c-table-column>
                            <c-table-column label="紧急程度" width="85" name="urgency_level">
                                <template #default="{data}">
                                    <c-state dict="urgencyLevelDic" :value="data.urgency_level"></c-state>
                                </template>
                            </c-table-column>
                            <c-table-column
                                    label="工单状态"
                                    width="85"
                                    name="status"
                            >
                                <template #default="{data}">
                                    <c-state dict="afterSaleOrderStateDic" tag :value="data.status"></c-state>
                                </template>
                            </c-table-column>
                            <c-table-column label="产品件数" width="100" name="product_count">
                                <template #default="{data}">
                                    {{data.product_count}}
                                </template>
                            </c-table-column>
                            <c-table-column label="工单安装进度" width="100" name="spec_model">
                                <template #default="{data}">
                                    <span v-if="!data.product_count || data.product_count==0">-</span>
                                    <c-progress v-else-if="data.status==5" :rate="[1, 1]" color="green"></c-progress>
                                    <c-progress v-else-if="data.product_count > 0" :rate="[data.completed_product_count, data.product_count]" :color="(data.completed_product_count/data.product_count>=1) ?'green':'blue'"></c-progress>
                                    <span v-else>-</span>
                                </template>
                            </c-table-column>
                            <c-table-column label="客户预约时间" width="170" name="appointment_start_time">
                                <template #default="{data}">
                                    <b>{{data.appointment_start_time}}</b> ~ <b>{{data.appointment_end_time}}</b>
                                </template>
                            </c-table-column>
                            <c-table-column label="预估总成本" width="100" name="estimated_cost_total">
                                <template #default="{data}">
                                    ￥{{data.estimated_cost_total}}
                                </template>
                            </c-table-column>
                            <c-table-column label="预计服务时长" width="100" name="estimated_service_days">
                                <template #default="{data}">
                                    {{data.estimated_service_days}}天
                                </template>
                            </c-table-column>
                            <c-table-column label="负责人" width="100" name="charge_user_realname">
                                <template #default="{data}">
                                    {{data.charge_user_realname}}
                                </template>
                            </c-table-column>
                            <c-table-column label="参与人" width="100" name="group_user_realname">
                                <template #default="{data}">
                                    {{data.group_user_realname}}
                                </template>
                            </c-table-column>
                            <c-table-column label="客户距离" width="100" name="customer_distance">
                                <template #default="{data}">
                                    {{data.customer_distance}}km
                                </template>
                            </c-table-column>
                            <c-table-column label="创建人" width="100" name="create_user_realname">
                                <template #default="{data}">
                                    {{data.create_user_realname}}
                                </template>
                            </c-table-column>
                            <c-table-column label="创建时间" width="100" name="create_date">
                                <template #default="{data}">
                                    {{data.create_date}}
                                </template>
                            </c-table-column>
                        </c-table>
                    </template>
                    <!--跟进日志-->
                    <c-title>跟进日志</c-title>
                    <c-table ref="logTable" border :paging="false">
                        <c-table-column label="操作时间" name="create_date" width="140"></c-table-column>
                        <c-table-column label="操作人" name="create_user_realname" width="100">
                            <template #default="{data}">
                                {{data.create_user_realname || '系统自动'}}
                            </template>
                        </c-table-column>
                        <c-table-column label="操作内容" name="remark" width="120"></c-table-column>
                        <c-table-column label="操作详情" width="200" :ellipsis="false">
                            <template #default="{data}">
                                <span>{{data.data_detail || '-'}}</span>
                            </template>
                        </c-table-column>
                    </c-table>
                </div>

            </module-col>
        </module>
    </c-dialog>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'aftersaleApplyDetail',

    props: {
        id: [String, Number]
    },

    data() {
        return {
            detailData: {},
            itemData: [],
            serviceProgressDic:[ {
                name: '创建工单',
            }, {
                name: '指派工单',
            }, {
                name: '工单确认',
            }, {
                name: '执行工单',
            }, {
                name: '工单完结',
            }, {
                name: '客户验收',
            }],
            orderData: [],
        }
    },

    computed: {
        // 获取dictName选项数据
        ...mapState(['orderTransferStatusDic','applyTagShortDic']),
    },

    methods: {
        open() {
            this.request({
                url: '/aftersale/apply/detail',
                data: {
                    id: this.id
                },
                loading: true,
                success: data => {
                    this.detailData = data.detailInfo;
                    this.itemData = data.itemList;
                    this.$refs.itemTable.setData(this.itemData);
                    if(this.detailData.work_order_id){
                        this.loadWorkOrder();
                    }
                    this.setLogList(data.logList);
                    this.$refs.dialog.open();
                }
            });
        },
        setLogList(logList) {
            if (!logList) return;
            logList.forEach(item => {
                if (!item.data_json || !item.data_json.length) {
                    item.data_detail = '';
                    return;
                }
                if (item.operation_type == 2) {
                    item.data_detail = item.data_json.map(field =>
                        `【${field.字段}】: 【${field.原值 || '空'}】 → 【${field.新值 || '空'}】`
                    ).join('；');
                } else {
                    item.data_detail = item.data_json.map(field => {
                        let key = Object.keys(field)[0];
                        return `${key}：${field[key]}`;
                    }).join('；');
                }
            });
            this.$refs.logTable.setData(logList);
        },
        loadWorkOrder() {
            this.request({
                url: '/after/sale/order/detail',
                data: {
                    id: this.detailData.work_order_id
                },
                loading: true,
                success: data => {
                    this.orderData =[
                        {
                            id: data.detailInfo.id,
                            order_number: data.detailInfo.order_number,
                            after_sale_outlet_name: data.detailInfo.after_sale_outlet_name,
                            urgency_level: data.detailInfo.urgency_level,
                            status: data.detailInfo.status,
                            product_count: data.detailInfo.product_count,
                            completed_product_count: data.detailInfo.completed_product_count,
                            appointment_start_time: data.detailInfo.appointment_start_time,
                            appointment_end_time: data.detailInfo.appointment_end_time,
                            estimated_cost_total: data.detailInfo.estimated_cost_total,
                            estimated_service_days: data.detailInfo.estimated_service_days,
                            charge_user_realname: data.detailInfo.charge_user_realname,
                            group_user_realname: data.detailInfo.group_user_realname,
                            customer_distance: data.detailInfo.customer_distance,
                            create_user_realname: data.detailInfo.create_user_realname,
                            create_date: data.detailInfo.create_date,
                        }
                    ];
                    this.$refs.orderTable.setData(this.orderData);
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.m-progress-center
    display flex
    justify-content center
    align-items center
    margin-top 50px
</style>
<style lang="stylus" scoped>
.m-detail-related
    margin-top 20px
</style>

